"use client";

import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScaleYourRetailEmpire() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="181380" id="scale-with-confidence" className="dark bg-background text-foreground relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-40">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,var(--color-chart-3)_0%,transparent_50%)] opacity-30 mix-blend-screen" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,var(--color-primary)_0%,transparent_50%)] opacity-20 mix-blend-screen" />
      </div>

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 pointer-events-none">
        <svg viewBox="0 0 1000 600" className="h-full w-full max-w-6xl animate-[pulse_6s_ease-in-out_infinite]" aria-hidden="true">
          {}
          <path d="M250,350 L450,200 L750,300 L850,500 L550,550 Z" fill="none" stroke="var(--color-primary)" strokeWidth="1.5" strokeDasharray="6 6" className="opacity-40" />
          <path d="M450,200 L550,550" fill="none" stroke="var(--color-primary)" strokeWidth="1" strokeDasharray="4 4" className="opacity-30" />
          <path d="M250,350 L750,300" fill="none" stroke="var(--color-primary)" strokeWidth="1" strokeDasharray="4 4" className="opacity-30" />
          <path d="M450,200 L850,500" fill="none" stroke="var(--color-chart-3)" strokeWidth="1" strokeDasharray="4 4" className="opacity-30" />

          {}
          <g fill="var(--color-primary)">
            {}
            <circle cx="250" cy="350" r="8" className="animate-[ping_3s_ease-in-out_infinite]" opacity="0.5" />
            <circle cx="250" cy="350" r="4" />
            
            {}
            <circle cx="450" cy="200" r="10" className="animate-[ping_4s_ease-in-out_infinite_0.5s]" fill="var(--color-chart-3)" opacity="0.5" />
            <circle cx="450" cy="200" r="6" fill="var(--color-chart-3)" />
            
            {}
            <circle cx="750" cy="300" r="8" className="animate-[ping_3.5s_ease-in-out_infinite_1s]" opacity="0.5" />
            <circle cx="750" cy="300" r="5" />
            
            {}
            <circle cx="850" cy="500" r="9" className="animate-[ping_4.5s_ease-in-out_infinite_1.5s]" fill="var(--color-chart-3)" opacity="0.5" />
            <circle cx="850" cy="500" r="5" fill="var(--color-chart-3)" />
            
            {}
            <circle cx="550" cy="550" r="7" className="animate-[ping_3s_ease-in-out_infinite_2s]" opacity="0.5" />
            <circle cx="550" cy="550" r="4" />
          </g>
        </svg>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mx-auto max-w-4xl space-y-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary backdrop-blur-md">
            <MapPin className="size-4" />
            <span>Built for Regulated Cannabis Operations</span>
          </div>
          
          <h2 className="text-5xl font-bold tracking-tighter sm:text-6xl md:text-7xl lg:text-8xl">
            Scale With <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-primary via-chart-3 to-primary bg-clip-text text-transparent">
              Confidence
            </span>
          </h2>
          
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground sm:text-xl font-normal leading-relaxed">
            Unify your POS, compliance, and CRM in one connected platform. 
            Cannabis Cloud simplifies complexity so you can focus on growth and patient engagement.
          </p>
          
          <div className="pt-8">
            <Button asChild size="lg" className="group h-16 rounded-full px-10 text-lg bg-gradient-to-r from-primary to-chart-4 shadow-[0_20px_40px_-10px_rgba(26,90,142,0.4)] transition-all hover:scale-105 hover:shadow-[0_25px_50px_-12px_rgba(26,90,142,0.5)]">
              <Link to="#">
                Launch Your Demo
                <ArrowRight className="ml-2 size-6 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
      
      {}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent pointer-events-none" />
    </section>;
}